import { render, staticRenderFns } from "./request-list-modal.vue?vue&type=template&id=0d35997a"
import script from "./request-list-modal.vue?vue&type=script&lang=js"
export * from "./request-list-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports